var SENTRY_RELEASE;SENTRY_RELEASE={name: "Vance - Expo App Dev", version: "1.0.0"};